"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASTopMenuToggleButton = void 0;
const IconToggleButton_1 = require("@nolimit/slot-launcher/bin/gui/buttons/IconToggleButton");
const PointerStateColorSet_1 = require("@nolimit/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet");
const GuiUtils_1 = require("@nolimit/slot-launcher/bin/gui/utils/GuiUtils");
const PointerStateIconSet_1 = require("@nolimit/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet");
const Icon_1 = require("@nolimit/slot-launcher/bin/gui/displayobjects/Icon");
const ImgLoader_1 = require("@nolimit/slot-launcher/bin/loader/ImgLoader");
const PromoPanelAssetConfig_1 = require("../../../config/PromoPanelAssetConfig");
const PromoPanelTextLabel_1 = require("../../PromoPanelTextLabel");
const PromoPanelTextStyles_1 = require("../../../config/PromoPanelTextStyles");
/**
 * Created by jonas on 2023-09-13.
 */
class ASTopMenuToggleButton extends IconToggleButton_1.IconToggleButton {
    constructor(id, labelString) {
        const onIcons = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.GAME_TYPE_ACTIVE)));
        const colors = new PointerStateColorSet_1.PointerStateColorSet(GuiUtils_1.GuiUtils.getARGB(PIXI.utils.string2hex("#f57f20")));
        const offIcons = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.GAME_TYPE_INACTIVE)));
        super(id, onIcons, colors, offIcons);
        this.label = this.createLabel(labelString, 250);
        this.label.onResize();
        this.addSubComponent(this.label, { x: 0.5, y: 0.5 }, { x: 0, y: 0 });
    }
    get toggled() {
        return super.toggled;
    }
    set toggled(value) {
        super.toggled = value;
        this.updateLabel();
    }
    updateLabel() {
        if (this.toggled) {
            this.label.setColor(GuiUtils_1.GuiUtils.getARGB(PIXI.utils.string2hex("#ffffff")));
        }
        else {
            this.label.setColor(GuiUtils_1.GuiUtils.getARGB(PIXI.utils.string2hex("#f57f20")));
        }
        this.addSubComponent(this.label, { x: 0.5, y: 0.5 }, { x: 0, y: 0 });
    }
    createLabel(labelString, maxWidth) {
        const buyLabel = new PromoPanelTextLabel_1.PromoPanelTextLabel(labelString, PromoPanelTextStyles_1.PromoPanelTextStyles.ACTION_SPINS_MAIN_GAME_LABEL, {
            landscapeMaxWidth: maxWidth,
            portraitMaxWidth: maxWidth,
        });
        buyLabel.anchor.set(0.5, 0.5);
        return buyLabel;
    }
}
exports.ASTopMenuToggleButton = ASTopMenuToggleButton;
//# sourceMappingURL=ASTopMenuToggleButton.js.map